import { View } from 'react-native';

const OrderedList = View;

export { OrderedList };
